module.exports = __webpack_public_path__ + "static/media/tipsImg2.a6802f22.jpg";